export default __webpack_public_path__ + "static/media/hanoi.f1b35330.png";